/**
 * 
 * @copyright     (c) 2024-2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/_components/SendMultipleButton/index.js
 * Created:       Mon May 06 2024
 * Modified By:   Greg Olive
 * Last Modified: Tue Nov 04 2025
 */

import React, { useContext } from 'react';
import { Button } from "@proxy/_components";
import { FormContext } from "@proxy/_contexts";
import { getImage } from "@root/_utils";

export default function SendMultipleButton({ bulkTranslations }) {

  const { loading, settings, fulfillmentType} = useContext(FormContext);

  const shouldShow = typeof(fulfillmentType) == 'string' && loading === false && (settings[fulfillmentType].giftcard.enable_bulk.toString() === "1" || settings[fulfillmentType].giftcard.enable_bulk === true);

  return ((shouldShow) ?
    <Button
      label={""}
      name={""}
      onClick={() => {
        window.location.href = `/a/gc/gift-card/${fulfillmentType}/bulk-order/`;
      }}
      type="button"
      fullWidth={false}
      subdued={true}
      borderLess={true}
      id="gcpShowBulk"
      image={null}
      disabled={false}
    >
      <img src={getImage("./icons/fontAwesome/list-numbered.svg")} alt="Send multiple icon" />
      {bulkTranslations.send_multiple}
    </Button>
  : null);
};
